import { Component, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { LinksService } from 'src/app/services/links.service';
import { LoginService } from 'src/app/services/login.service';
import { TabsService } from 'src/app/services/tabs.service';
import { EventsService } from '../../services/events.service';
import { AnalyticsService } from '../../services/analytics.service';
import { Capacitor } from '@capacitor/core';
import { Keyboard } from '@capacitor/keyboard';
import { Platform } from '@ionic/angular';

@Component({
  selector: 'tabs',
  templateUrl: 'tabs.html',
  styleUrls: ['tabs.scss']
})
export class TabsComponent {
  tabs$;
  showLabels;
  user;
  public showTabs = true;
  constructor(
    tabsService: TabsService,
    private linkProvider: LinksService,
    private router: Router,
    public loginService: LoginService,
    private eventsService: EventsService,
    private ngZone: NgZone,
    public platform: Platform,
    private analyticsService: AnalyticsService
  ) {
    this.eventsService.subscribe({ name: 'session', value: 'ready' }).subscribe(() => {
      this.tabs$ = tabsService.get();
      this.showLabels = loginService.rescueAppTheme().tabs.showLabels;
      this.user = loginService.rescueSessionDataUser()
    });

    if (this.platform.is('capacitor')) {
      Keyboard.addListener('keyboardWillShow', () => {
        this.ngZone.run(() => {
          this.showTabs = false;
        });
      });

      Keyboard.addListener('keyboardWillHide', () => {
        this.ngZone.run(() => {
          this.showTabs = true;
        });
      });
    }
  }

  public open(link) {
    this.registerEventInAnalytics(link);
    const handlerLinkType = this.linkProvider.linkType[link.targetType];
    handlerLinkType(link);
  }

  registerEventInAnalytics(link) {
    const paramsToAnalytics = { actions: 1 };
    const name = link.textToDisplay || link.label || link.name;
    const id = link.id ? parseInt(link.id) : undefined;
    this.analyticsService.registerEvent(paramsToAnalytics, name, id);
  }


  public navigateToPoints(){
    this.router.navigate(['/profile/loyalitix-points-log'])
  }
}
